export default "__VITE_ASSET__D0MfegaB__"